import { useState } from "react";
import { AssessmentStatus, Leads } from "../../../../../model/leads/leads";
import styles from "../../LeadsPage.module.scss";
import NewLeadSideDialog from "./NewLeadsSideDialog";
import { calculateTimeDifference, formatDate, formatEnumString } from "../../../../../utils";
import LeadsTable, { Column } from "../LeadsTable";

interface NewLeadsProps {
	data: Leads[];
}
const NewLeads = ({ data }: NewLeadsProps) => {
	const [openSideDialogue, setOpenSideDialogue] = useState(false);
	const [selectedLead, setSelectedLead] = useState<Leads>();

    const handleDetailView = (item : Leads) =>{
        setOpenSideDialogue(true)
        setSelectedLead(item);
    }

    const columns: Column<Leads>[] = [
		{
			header: "CUSTOMER NAME",
			accessor: "user",
			render: item => `${item.user?.firstName || ''} ${item.user?.lastName || ''}`,
		},
		{
			header: "LEAD STATUS",
			accessor: "status",
			render: item => formatEnumString(AssessmentStatus[item.status])
		},
		{
			header: "DATE CREATED",
			accessor: "createdAt",
			render: item => formatDate(item.createdAt),
		},
		{
			header: "TIMELINE",
			accessor: "assessmentDetails",
			render: item => <span className={styles.subSubText}>{calculateTimeDifference(item.createdAt)}</span>,
		},
		{
			header: "VIEW DETAILS",
			accessor: "id",
			render: item => (
				<button className="actionButton" onClick={() => handleDetailView(item)}>
					VIEW DETAILS
				</button>
			),
		},
	];

	return (
		<>
			{openSideDialogue && selectedLead && <NewLeadSideDialog data={selectedLead} onClose={() => setOpenSideDialogue(false)} />}
			<LeadsTable<Leads>
              columns={columns}
              data={data}
              tableContainerClassName={styles.tableContainer}
            />
		</>
	);
};
export default NewLeads;
